import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import { EntityLink } from "../entity-link";
import Resource from "./resource";

@JsonObject()
export class RelationResource extends Resource {
    @JsonProperty("parents")
    @JsonElementType(EntityLink)
    parents?: Array<EntityLink>;

    @JsonProperty("parent")
    @JsonElementType(EntityLink)
    parent?: EntityLink;

    @JsonProperty("children")
    @JsonElementType(EntityLink)
    children?: Array<EntityLink>;

    @JsonProperty("child")
    @JsonElementType(EntityLink)
    child?: EntityLink;

    @JsonProperty("inherits_security")
    inheritsSecurity?: boolean;

    @JsonProperty("parent_total")
    parentTotal?: number;

    @JsonProperty("child_total")
    childTotal?: number;

    constructor(init?: Partial<RelationResource>) {
        super();
        Object.assign(this, init);
    }

    /**
     * Merges two relation resources.
     *
     * This should be used for self referencing relations, where there can be no conflicts
     * between the two existing resources.
     * @param main - Source to use as defaults
     * @param toMerge - Source to use to set relation links
     */
    static merge(main: RelationResource, toMerge: RelationResource): RelationResource {
        const result = new RelationResource({
            child: main.child,
            children: main.children,
            inheritsSecurity: main.inheritsSecurity,
            parent: main.parent,
            parents: main.parents,
            self: main.self,
        });

        if (toMerge.child != null) {
            result.child = toMerge.child;
        }

        if (toMerge.children != null) {
            result.children = toMerge.children;
        }

        if (toMerge.parent != null) {
            result.parent = toMerge.parent;
        }

        if (toMerge.parents != null) {
            result.parents = toMerge.parents;
        }

        return result;
    }
}
